import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import API from "../../Network/API";
import PostLoader from '../../assets/loader.gif';
import UserAvatar from "../../components/UserAvatar";

export default function EnrollmentCourseDetails() {
    const dispatch = useDispatch();
    const [data, setData] = useState()
    const prams = useParams();
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true)
        API.get(`/v1/oauth/teacher/order-details/${prams?.id}`)
            .then((response) => {
                setData(response.data.data)
                setLoading(false)
            }).catch((error) => {
                setLoading(false)
            });

    }, [prams?.id]);

    const amount = Number(data?.course?.payment_info?.amount ?? 0);

    return (
        <>
            {isLoading ?
                <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
                    <img src={PostLoader} alt='Post loader' height={80} width={80} />
                </div>
                :
                <>
                    <div className="dashboard-title d-flex align-items-center">
                        <Link to={`/dashboard/all-enrollment-courses`} className="back-circle-btn me-3" title="Back to Classes">
                            <i className="fa-light fa-arrow-left" />
                        </Link>
                        <h4 className="mb-0">Order Details</h4>
                    </div>

                    <div className="row">
                        <div className="col-lg-7 mb-3">
                            <div className="dash-card h-100">
                                <p className="order-detail-label">Course</p>
                                <div className="d-flex order-detail-course">
                                    <img
                                        className="order-detail-cover flex-shrink-0"
                                        src={data?.course?.cover_image || '/assets/img/no_image.jpg'}
                                        alt={data?.course?.course_title || 'Course cover'}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = '/assets/img/no_image.jpg';
                                        }}
                                    />
                                    <div className="ms-3 min-w-0">
                                        <span className={`status-badge ${data?.course?.course_type == 'recorded' ? 'muted' : 'ok'}`}>
                                            {data?.course?.course_type == 'recorded' ? 'Recorded' : 'Live'}
                                        </span>
                                        <h5 className="order-detail-title mt-2 mb-1">{data?.course?.course_title}</h5>
                                        {data?.course?.lesson_name &&
                                            <p className="order-detail-lesson mb-1"><i className="fa-light fa-book-open me-2" />{data?.course?.lesson_name}</p>
                                        }
                                        <p className="order-detail-price mb-0">{amount > 0 ? `$${amount.toFixed(2)}` : 'Free'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 mb-3">
                            <div className="dash-card h-100">
                                <p className="order-detail-label">Student</p>
                                <div className="d-flex align-items-center">
                                    <UserAvatar src={data?.course?.student_image} name={data?.course?.student_name} size={56} />
                                    <div className="ms-3 min-w-0">
                                        <h6 className="order-detail-title mb-0">{data?.course?.student_name}</h6>
                                        <p className="order-detail-lesson mb-0">{data?.course?.student_email}</p>
                                    </div>
                                </div>
                                <Link to={`/dashboard/chat/conversation/${data?.course?.student_id}`} className="row-action-btn primary mt-3">
                                    <i className="fa-light fa-message-lines" />Message Student
                                </Link>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="dashboard-title">
                                <h4>Earning Details</h4>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="table-responsive custom-table">
                                <table className="table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Order Date</th>
                                            <th>Title</th>
                                            <th>Amount</th>
                                            <th>Fee</th>
                                            <th>Clearance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td data-label="Order Date">{data?.course?.created_at}</td>
                                            <td data-label="Title">{data?.course?.lesson_name || data?.course?.course_title}</td>
                                            <td data-label="Amount">${amount.toFixed(2)}</td>
                                            <td data-label="Fee">{data?.earning_info?.fees != null ? `$${Number(data?.earning_info?.fees).toFixed(2)}` : '—'}</td>
                                            <td data-label="Clearance">
                                                {data?.earning_info?.approved == '1' ?
                                                    <span className="status-badge ok">Approved</span>
                                                    :
                                                    <span className="status-badge pending">Pending</span>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </>
            }
        </>
    )
}
